import React, { useState, useEffect } from 'react';
import { useCloseOnEscape } from '../../hooks/useCloseOnEscape';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setShowConsent(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  useCloseOnEscape(showConsent, declineCookies);

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent">
        <div className="cookie-content">
          <div className="cookie-header">
            <h3 className="cookie-title">We use cookies</h3>
            <p className="cookie-description">
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies.
            </p>
          </div>
          
          <div className="cookie-actions">
            <button 
              className="cookie-btn decline-btn" 
              onClick={declineCookies}
            >
              Decline
            </button>
            <button 
              className="cookie-btn accept-btn" 
              onClick={acceptCookies}
            >
              Accept All
            </button>
          </div>
          
          <div className="cookie-links">
            <a href="/privacy" className="cookie-link">Privacy Policy</a>
            <span className="cookie-separator">•</span>
            <a href="/terms" className="cookie-link">Terms of Use</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

